export default __webpack_public_path__ + "static/media/nodo.0cdea397.png";